import { PropertyImageModel } from 'common/data/property-image/model';
import { ImageGalleryItemInterface } from 'common/module/image-gallery/item.interface';
import { ImageGalleryItemTypeEnum } from 'common/module/image-gallery/item-type.enum';

export const galleryItemsMapper = (
  images: PropertyImageModel[],
  size: keyof PropertyImageModel['links'],
  propertyId: string
): ImageGalleryItemInterface[] =>
  images.map((image) => ({
    type: ImageGalleryItemTypeEnum.IMAGE,
    sourceUrl: image.links[size],
    thumbUrl: image.links.thumb,
    propertyId,
    classificationLabel: image.classification_label,
  }));
